import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { adminPermissionsArray, languagesArray, permissionsArray, rolesArray, staffServicePermissionsArray } from 'src/types';
import { z } from 'zod';

import { isValidE164, normalizePhoneE164 } from '../../../../utils/normalizePhone';
import { userFormError } from '../../../../variables';

export const schemaUser = z.object({
  name: z.string().min(1, userFormError.name.empty),
  surname: z.string().min(1, userFormError.surname.empty),
  email: z.string().min(1, userFormError.email.empty).email('Podaj poprawny adres e-mail'),
  role: z.enum(rolesArray),
  associated_organization: z.string().optional(),
  organizations: z.array(z.string()).min(1, 'Musisz wybrać co najmniej jedną organizację'),
  // Telefon jest OPCJONALNY (konto zakłada się na e-mail), ale jeśli ktoś go poda,
  // to jest to login do aplikacji Staff (SMS OTP) — do Firebase Auth MUSI trafić
  // czyste E.164 (bez spacji/myślników), inaczej Auth odrzuci numer albo logowanie
  // SMS-em trafi w NOWE konto. Normalizujemy wejście, dopiero potem walidujemy wynik.
  phoneNumber: z.string()
    .optional()
    .transform((value) => normalizePhoneE164(value ?? ''))
    .refine(
      (value) => value === '' || isValidE164(value),
      'Podaj poprawny numer telefonu, np. +48 123 456 789',
    ),
  permissions: z.array(z.enum(permissionsArray)).optional(),
  staffServicePermissions: z.array(z.enum(staffServicePermissionsArray)).optional(),
  // Organizacje, których TEN user jest właścicielem — puste = zwykły personel.
  owner: z.array(z.string()).optional(),
  isHotelspotAdmin: z.boolean().optional(),
  // Zawężenie uprawnień admina — puste = pełny dostęp.
  adminPermission: z.enum(adminPermissionsArray).optional(),
  language: z.enum(languagesArray).optional(),
});

export type UserEntity = z.infer<typeof schemaUser>;

const userResolver: Resolver<UserEntity> = zodResolver(schemaUser) as never;

export const userFormOptions: UseFormProps<UserEntity> = {
  mode: 'onSubmit',
  resolver: userResolver,
};
